"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var HeDatatableHeader_vue_1 = __importDefault(require("./HeDatatableHeader.vue"));
var models_1 = require("./models");
var moment_addon_1 = __importDefault(require("../../Addons/moment-addon"));
// import "./configuration";
exports.default = vue_1.default.extend({
    name: "HeDatatable",
    props: {
        /**
         * Controller contenant la méthode de
         * récupration des données
         */
        dtLoadController: {
            default: function () { return null; },
        },
        /**
         * Méthode de récupération de données
         */
        dtLoadAction: {
            default: function () { return null; },
        },
        /**
         * Colonnes à utiliser dans le datatable
         */
        dtColumns: {
            default: null,
        },
        /**
         * Objet représentant le tri du datatable
         */
        dtOrder: {
            default: null,
        },
        /**
         * Nombre d'élément par page
         */
        dtPageLength: {
            default: function () { return 25; },
        },
        /**
         * Page courante
         */
        dtPageStart: {
            default: function () { return 1; },
        },
        /**
         * Configuration du dom (en langage dom datatable)
         */
        dtDom: {
            default: function () { return 'rt<"bottom w-100 text-center py-3"pl>i<"clear">'; },
        },
        /**
         * Listes des filtres personnalisés
         */
        dtCustomFilters: {
            default: null,
        },
        /**
         * Liste des variables personnélisées
         */
        dtCustomVars: {
            default: null,
        },
        /**
         * Nombre de résultat affiché au chargement de la page (0 pour ne pas avoir de chargement)
         */
        dtDeferLoadingNb: {
            default: null,
        },
        /**
         * Url de méthode permettant l'export Csv
         * des données du datatable
         */
        dtCsvGeneratorUrl: {
            default: function () { return ""; },
        },
        /**
         * Boolean présisant si le menu d'action doit être affiché
         */
        dtActionMenu: {
            default: function () { return true; },
        },
        /**
         * Boolean précisant si la recherche textuelle doity être affichée
         */
        dtSearchInput: {
            default: function () { return true; },
        },
        /**
         * Pré recherche textuelle a effectuer par défaut
         */
        dtPreSearch: {
            default: function () { return null; },
        },
        /**
         * Format affichage des dates dans le datatable
         */
        dtFormatDate: {
            default: function () { return "DD/MM/YYYY"; },
        },
        /**
         * Fonction de génération de la requête ajax pour charger le datatable
         */
        dtBuildParamFunc: {
            default: function () { return null; },
        },
        /**
         * Fonction qui renvoie de la liste des colonnes
         *  affichés par la requête ajax
         */
        dtUpdateColumnsListFunc: {
            default: function () { return null; },
        }
    },
    data: function () {
        var columns = this.dtColumns ? this.dtColumns : [], order = this.dtOrder ? this.dtOrder : [], custom_filters = this.dtCustomFilters
            ? this.dtCustomFilters
            : [], custom_vars = this.dtCustomVars ? this.dtCustomVars : {};
        return {
            datatable: null,
            columns: columns,
            order: order,
            custom_filters: custom_filters,
            custom_vars: custom_vars,
            options: null,
            columnsDatas: [],
            searchCols: [],
            has_actions_menu: this.dtActionMenu,
            has_search_input: this.dtSearchInput,
            search_input_value: null,
            current_search_value: 0,
            timeout: null,
        };
    },
    created: function () {
        // Construction de la liste de colonnes et des filtres par défaut
        this.buildColumnAndFilter();
        // Récupération des options pour le datatable
        this.options = this.getOptions();
    },
    methods: {
        /**
         * Evenement lancé à la saisie dans la recherche textuelle
         */
        onSearch: function () {
            var _this = this;
            if (this.timeout) {
                clearTimeout(this.timeout);
            }
            this.timeout = setTimeout(function () {
                var searchString = [], valSearch = _this.search_input_value &&
                    _this.search_input_value.length === 0
                    ? null
                    : _this.search_input_value;
                if (valSearch &&
                    valSearch.length < 2 &&
                    valSearch.length > _this.current_search_value) {
                    return;
                }
                if (_this.pre_search) {
                    searchString.push(_this.pre_search);
                }
                _this.current_search_value = valSearch;
                searchString.push(valSearch);
                _this.datatable.search(searchString.join(",")).draw();
            }, 300);
        },
        /**
         * Lancé au click sur une ligne du tableau en cas d'Url précisée dans les données
         */
        onRowClick: function (url) {
            document.location.assign(url);
        },
        /**
         * Lancé à la validation des filtres de colonnes
         */
        applyFilter: function (event, column, searchs) {
            var $this = $(event.target), dbcolumn = this.datatable.columns(column.name + ":name");
            this.$set(column, "search", searchs);
            this.setSearchValues(dbcolumn, searchs);
            this.datatable.draw();
        },
        /**
         * Lancé à la suppression d'un filtrage sur une colonne
         */
        deleteFilter: function (event, column, searchs) {
            var dtColumn = this.datatable.columns(column.name + ":name");
            this.$set(column, "search", searchs);
            this.setSearchValues(dtColumn, searchs);
            this.datatable.draw();
        },
        /**
         * Lancé par datatable à la création des lignes du tableau
         */
        createdRow: function (row, data) {
            if (data["RouteUrl"]) {
                $(row).attr("data-route-url", data["RouteUrl"]);
            }
            if (data["DataAttribut"]) {
                var colsAttr = JSON.parse(data["DataAttribut"]);
                var ths = this.$table.find("th");
                var tds = $(row).find("td");
                for (var property in colsAttr) {
                    if (colsAttr.hasOwnProperty(property)) {
                        var i = ths.index($("th[data-column=" + property + "]")), $td = $(tds[i]), attrs = JSON.parse(colsAttr[property]);
                        for (var prop in attrs) {
                            if (attrs.hasOwnProperty(prop)) {
                                $td.attr("data-" + prop, attrs[prop] instanceof Object
                                    ? JSON.stringify(attrs[prop])
                                    : attrs[prop]);
                            }
                        }
                    }
                }
            }
            this.$emit("createdRow", { row: row, data: data });
        },
        /**
         * Lancé lors de la demande d'export des données du datatable
         * dans le menu action
         */
        downloadCsv: function () {
            var datatable = this.datatable;
            if (!datatable) {
                return;
            }
            var params = datatable.ajax.params();
            params.data.columns = this.adjustDefinitionColumns(this.columns, params.data.columns);
            var $f = $("<form method=\"post\" action=\"" + this.dtCsvGeneratorUrl + "\" style=\"display: none;\">");
            var $params = $('<input type="hidden" name="parameters">').val(JSON.stringify(params.data));
            $f.append($params);
            $("body").append($f);
            $f.trigger("submit").remove();
        },
        /**
         * Lancé par datatable au changement de page
         */
        onPageDt: function () {
            $("ul.pagination input.page", $(this.$el)).val(this.datatable.page() + 1);
            this.$emit("filter-change", { source: "page.dt" });
        },
        /**
         * Lancé par datatable à la création du tableau
         */
        onDraw: function () {
            this.$emit("draw");
        },
        /**
         * Génération des données et filtres de colonne
         */
        buildColumnAndFilter: function () {
            var _this = this;
            this.columnsDatas = [];
            this.columns.map(function (def) {
                _this.columnsDatas.push({
                    data: {
                        _: def.name,
                        displayable: def.displayable,
                    },
                    name: def.name,
                    visible: def.visible,
                    orderable: def.orderable,
                    searchable: def.searchable,
                    search: def.search,
                    operatorfilter: def.operatorfilter,
                    render: function (data) {
                        if (!data) {
                            return "";
                        }
                        if (def.type === "date") {
                            return data ? moment_addon_1.default(data).format(_this.dtFormatDate) : "";
                        }
                        if (data instanceof Array) {
                            if (data.length == 0) {
                                return "";
                            }
                            var list = $("<ul class='datatable-cell-list'>");
                            for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                                var item = data_1[_i];
                                list.append($("<li>").append(item.url
                                    ? $("<a>", { href: item.url }).text(item.label)
                                    : item.label));
                            }
                            return list[0].outerHTML;
                        }
                        return data;
                    },
                });
                var searchValue = null, searchvalues = [];
                if (def.search && def.search.value != null) {
                    searchValue = def.search.value;
                    try {
                        searchvalues = JSON.parse(searchValue);
                    }
                    catch (_a) {
                        searchvalues = searchValue;
                    }
                }
                _this.searchCols.push({
                    search: searchValue,
                });
            });
        },
        /**
         * Récupération des options pour l'instanciation du datatable
         */
        getOptions: function () {
            var self = this;
            var options = {
                destroy: true,
                lengthMenu: [10, 25, 50, 75, 100],
                pageLength: this.dtPageLength,
                displayStart: this.dtPageLength * (this.dtPageStart - 1),
                dom: this.dtDom,
                language: {
                    processing: '<i class="fa fa-spinner fa-spin fa-5x"></i>',
                },
                processing: true,
                serverSide: true,
                autoWidth: false,
                responsive: true,
                order: this.order && this.order.length > 0
                    ? this.order.map(function (_) { return [_.column, _.dir]; })
                    : [],
                columns: this.columnsDatas,
                searchCols: this.searchCols,
                createdRow: function (row, data, dataIndex) {
                    self.createdRow(row, data);
                }
            };
            if (this.dtLoadController && this.dtLoadAction) {
                options.ajax = {
                    url: "/" + this.dtLoadController + "/" + this.dtLoadAction,
                    type: "POST",
                    dataType: "json",
                    data: function (d) {
                        d["customVars"] = self.custom_vars;
                        d["columns"] = self.adjustDefinitionColumns(self.columns, d["columns"]);
                        if (self.dtBuildParamFunc) {
                            d = $(self.$el)[self.dtBuildParamFunc](d);
                        }
                        return {
                            data: d,
                        };
                    },
                    error: function (xhr) {
                        if (xhr && xhr.status == 401) {
                            document.location.reload();
                            return;
                        }
                        throw new Error("Ajax error");
                    },
                    dataSrc: function (data) {
                        if (data.customVars.colsToShow) {
                            var displayColumns = [];
                            if (data.customVars.colsToShow instanceof Array) {
                                data.customVars.colsToShow.map(function (_) {
                                    var column = self.columns.find(function (c) { return c.name === _; });
                                    self.setVisibleColumn(column, true);
                                });
                                displayColumns = data.customVars.colsToShow;
                            }
                            else {
                                var column = self.columns.find(function (_) { return _.name === data.customVars.colsToShow; });
                                self.setVisibleColumn(column, true);
                                displayColumns = [data.customVars.colsToShow];
                            }
                            if (self.dtUpdateColumnsListFunc) {
                                $(self.$el)[self.dtUpdateColumnsListFunc](displayColumns);
                            }
                        }
                        return data.data;
                    }
                };
            }
            if (this.dtDeferLoadingNb || this.dtDeferLoadingNb === 0) {
                options.iDeferLoading = this.dtDeferLoadingNb;
            }
            if (this.pre_search) {
                options.search = { search: this.pre_search };
            }
            return options;
        },
        /**
         * Passage des données de recherche à datatable
         */
        setSearchValues: function (column, searchs) {
            column.search(searchs && searchs.length > 0
                ? JSON.stringify($.extend(true, [], searchs)
                    .map(function (s) {
                    if (typeof s === "object") {
                        if (typeof s.value === "object") {
                            s.value = s.value.join(",");
                        }
                    }
                    return s;
                }))
                : "");
        },
        /**
         * Evènement lancé lors du choix d'affichage de colonne
         * dans la liste déroulante
         */
        selectedColumn: function (event, column) {
            event.stopPropagation();
            var $chkb = $(event.target), isChecked = $chkb.is(":checked");
            this.setVisibleColumn(column, isChecked);
            if (column.inothertable) {
                this.datatable.draw();
            }
        },
        setVisibleColumn: function (column, visible) {
            var dbCol = this.datatable.columns(column.name + ":name");
            column.visible = visible;
            dbCol.visible(visible);
        },
        /**
         * Ajout des propriétés manquantes sur les colonnes
         * pour le requêtage
         */
        adjustDefinitionColumns: function (columns, tocolumns) {
            $.map(columns, function (c) {
                var column = tocolumns.find(function (_) { return _.name === c.name; });
                $.each(c, function (name, value) {
                    if (!column[name]) {
                        column[name] = value;
                    }
                });
            });
            return tocolumns;
        },
        /**
         * Permet la fermeture du popover contenant les filtres d'une colonne
         */
        closeAllPopover: function () {
            this.$children.map(function (c) { return (c.popoverShow = false); });
        },
        /**
         * Méthode pour initialiser le datatable
         */
        initDatatable: function () {
            var self = this, $$el = $(this.$el);
            this.datatable = $(this.$refs.table).DataTable(this.options);
            this.datatable
                .on("page.dt", function () {
                self.onPageDt();
            })
                .on("draw", function () {
                self.onDraw();
            });
            $$el.on("click", "th.orderable", function () {
                self.$emit("filter-change", { source: "sort" });
            })
                // Connexion à la pagination
                .on("click", "ul.pagination a", function () {
                var $this = $(this), $li = $this.parent(), $ul = $li.parent(), $first = $("li.page-item:not(.previous):first", $ul), $last = $("li.page-item:not(.next):last", $ul);
                if ($li === $first) {
                    self.$emit("filter-change", {
                        source: "page.first",
                    });
                }
                else if ($li === $last) {
                    self.$emit("filter-change", {
                        source: "page.last",
                    });
                }
                else if ($li.hasClass("previous")) {
                    self.$emit("filter-change", {
                        source: "page.previous",
                    });
                }
                else if ($li.hasClass("next")) {
                    self.$emit("filter-change", {
                        source: "page.next",
                    });
                }
                else {
                    self.$emit("filter-change", {
                        source: "page.input",
                    });
                }
                $(this).trigger("blur");
            })
                .on("change", "div.dataTables_length select", function () {
                self.$emit("filter-change", {
                    source: "length.change",
                });
            })
                .on("click", "tr[data-route-url]", function () {
                self.onRowClick($(this).data("route-url"));
            });
        },
        refreshDatatable: function (columns) {
            this.columns = columns;
            this.buildColumnAndFilter();
            this.options = this.getOptions();
            this.datatable = $(this.$refs.table).DataTable(this.options);
        },
        emptySearch: function () {
            var _this = this;
            this.datatable.search("");
            this.search_input_value = "";
            this.columns.map(function (column) {
                var dbcolumn = _this.datatable.columns(column.name + ":name");
                dbcolumn.search("");
                column.search = [];
            });
        }
    },
    computed: {
        $table: function () {
            return $(this.$refs.table);
        },
        paramsAjax: function () {
            return this.datatable.ajax.params().data;
        },
        DatatableColumnTypeEnum: function () {
            return models_1.DatatableColumnTypeEnum;
        },
        DatatableSelectTypeEnum: function () {
            return models_1.DatatableSelectTypeEnum;
        },
        ColumnsToDisplay: function () {
            return this.columns.filter(function (c) { return c.name !== "RouteUrl" && c.displayable; });
        },
    },
    components: {
        HeDatatableHeader: HeDatatableHeader_vue_1.default,
    },
    mounted: function () {
        this.initDatatable();
    },
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/SharedComponent/HeDatatable/HeDatatable.vue
// module id = 224
// module chunks = 0